<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="终端主机号/车牌号/车架号"
             style="width: 200px; margin-right: 3px;"></Input>
      <DatePicker size="small" type="daterange" v-model="selectAnalysisDatetime" placeholder="选择日期"
                  style="margin-right: 3px; width: 200px;"></DatePicker>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button size="small" type="primary" style="margin-right: 10px;" @click="onExportExcelClick">导出</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange"
                 @contextmenu.prevent.native="onTableRightClick($event)" @on-select="onselect" @on-select-all="onselectall"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true"
              show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>
      </div>
    </Row>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                             v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
import { genURLParams } from '@/libs/urlparamhelper'

export default {
  name: 'gnssreports',
  components: {

  },
  data () {
    return {

      selectAnalysisDatetime: [],

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      gpsEnableFilter: null,
      galileoEnableFilter: null,
      glonassEnableFilter: null,
      beidouEnableFilter: null,

      offlineFilter: null,

      // 分析结果处理
      processAnalysisResultModal: false,
      processAnalysisResultId: null,

      // 批量分析结果处理
      batchProcessAnalysisResultModal: false,
      batchProcessAnalysisResultId: null,

      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '终端主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '车辆信息',
          resizable: true,
          key: 'vehicleInfoId',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 220,
          render: function (h, params) {
            if (params.row.vehicleInfo) {
              let vehicleInfo = params.row.vehicleInfo
              let display = []
              display.push(h('div', '车牌号码:' + (vehicleInfo.registrationNum == null ? '' : vehicleInfo.registrationNum)))
              display.push(h('div', '车架号:' + (vehicleInfo.vin == null ? '' : vehicleInfo.vin)))
              return h('div', display)
            }
          }
        },
        {
          title: '分组名称',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          minWidth: 150,
          render: function (h, params) {
            if (params.row.vehicleInfo && params.row.vehicleInfo.vehicleInfoGroup) {
              return h('div', params.row.vehicleInfo.vehicleInfoGroup.name)
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '终端信息型号',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          render: function (h, params) {
            if (params.row.positioningDeviceInfo && params.row.positioningDeviceInfo.positioningDeviceModel) {
              return h('div', params.row.positioningDeviceInfo.positioningDeviceModel.name)
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '启用GPS',
          resizable: true,
          key: 'gpsEnable',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '是', value: true },
            { label: '否', value: false }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.gpsEnableFilter = []
              val.forEach(item => {
                this.gpsEnableFilter.push(genQueryParam('gpsEnable', 'EQBOOL', item))
              })
            } else {
              this.gpsEnableFilter = null
            }
          },
          render: (h, params) => {
            let state = params.row.gpsEnable
            if (state === true) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'green'
                  }
                }, '是')
              ])
            } else if (state === false) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '否')
              ])
            }
          }
        },
        {
          title: '启用北斗',
          resizable: true,
          key: 'beidouEnable',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '是', value: true },
            { label: '否', value: false }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.beidouEnableFilter = []
              val.forEach(item => {
                this.beidouEnableFilter.push(genQueryParam('beidouEnable', 'EQBOOL', item))
              })
            } else {
              this.beidouEnableFilter = null
            }
          },
          render: (h, params) => {
            let state = params.row.beidouEnable
            if (state === true) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'green'
                  }
                }, '是')
              ])
            } else if (state === false) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '否')
              ])
            }
          }
        },
        {
          title: '启用Galileo',
          resizable: true,
          key: 'galileoEnable',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '是', value: true },
            { label: '否', value: false }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.galileoEnableFilter = []
              val.forEach(item => {
                this.galileoEnableFilter.push(genQueryParam('galileoEnable', 'EQBOOL', item))
              })
            } else {
              this.galileoEnableFilter = null
            }
          },
          render: (h, params) => {
            let state = params.row.galileoEnable
            if (state === true) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'green'
                  }
                }, '是')
              ])
            } else if (state === false) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '否')
              ])
            }
          }
        },
        {
          title: '启用Glonass',
          resizable: true,
          key: 'glonassEnable',
          ellipsis: 'true',
          tooltip: 'true',
          width: 150,
          filters: [
            { label: '是', value: true },
            { label: '否', value: false }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.glonassEnableFilter = []
              val.forEach(item => {
                this.glonassEnableFilter.push(genQueryParam('glonassEnable', 'EQBOOL', item))
              })
            } else {
              this.glonassEnableFilter = null
            }
          },
          render: (h, params) => {
            let state = params.row.glonassEnable
            if (state === true) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'green'
                  }
                }, '是')
              ])
            } else if (state === false) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '否')
              ])
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'GnssReportServ_GetPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      this.setPage(1)
    },
    onExportExcelClick () {
      let queryParams = []

      if (this.selectAnalysisDatetime[0] && this.selectAnalysisDatetime[1]) {
        let startDatetime = new Date(this.selectAnalysisDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectAnalysisDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        queryParams.push(genQueryParam('censusDatetime', 'BTDT', startDatetime, endDatetime))
      }
      let urlparams = {
        q: queryParams,
        keyword: this.keywordFilter
      }
      let url = '/api/da/gnssreport/exportexcel' + genURLParams(urlparams)
      window.location.href = url
    },
    filterChange () {
      this.setPage(1)
    },
    onselect (selection, row) {
      this.processAnalysisResultList = []
      selection.forEach(item => {
        this.processAnalysisResultList.push(item.id)
      })
    },
    onselectall (selection) {
      this.processAnalysisResultList = []
      selection.forEach(item => {
        this.processAnalysisResultList.push(item.id)
      })
    },
    onprocessAnalysisResult () {
      /**
         * 给id列表
         * 给处理内容
         * 后端批量处理
         */
      this.batchProcessAnalysisResultModal = true
      this.batchProcessAnalysisResultId = this.processAnalysisResultList
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let sortParam = null

      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }
      if (this.selectAnalysisDatetime[0] && this.selectAnalysisDatetime[1]) {
        let startDatetime = new Date(this.selectAnalysisDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectAnalysisDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
      }

      if (this.gpsEnableFilter) {
        qo1 = this.gpsEnableFilter
      }
      if (this.beidouEnableFilter) {
        qo2 = this.beidouEnableFilter
      }
      if (this.glonassEnableFilter) {
        qo3 = this.glonassEnableFilter
      }
      if (this.galileoEnableFilter) {
        qo4 = this.galileoEnableFilter
      }

      store.dispatch('GnssReportServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          qo2: qo2,
          qo3: qo3,
          qo4: qo4,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_GnssReport_GetPageResult) {
        return store.getters.get_GnssReport_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_GnssReport_GetPageResult) {
        return store.getters.get_GnssReport_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_GnssReport_GetPageResult) {
        return store.getters.get_GnssReport_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
